/* eslint-disable no-unused-vars */
import { Box, Chip, Dialog, DialogActions, DialogContent, DialogTitle, Typography, Tooltip } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { IoAdd } from 'react-icons/io5'
import { RiDeleteBin5Line } from 'react-icons/ri'
import { Button } from 'src/Common/ui/button'
import Textarea from 'src/Common/ui/textArea'
import * as RiskTypes from '../../Entities/RiskTypes'
import SaveCancelButton from 'src/Common/ui/SaveCancelButton'
import { cn, inputValidation } from '../../lib/utils'
import { useTranslation } from 'react-i18next'
import Heatmap from 'react-heatmap-grid'
import { Tabs, TabsList, TabsTrigger } from 'src/Common/ui/tabs'
import { Checkbox } from 'src/Common/ui/checkbox'
import ThreePointEstimate from 'src/Components/Risk/ThreePointEstimate'
import DecisionTreeAnalysis from 'src/Components/Risk/DecisionTreeAnalysis'
import ExpectedMonetaryValue from 'src/Components/Risk/ExpectedMonetaryValue.js'
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router'
import * as IssueTypes from 'src/Entities/IssueTypes'
// import * as RoutePath from '../../Entities/RoutePath'
import { useSettingsStore } from 'src/Containers/SettingsContainer/Store/Store'
import { createRiskAnalysis } from 'src/API/RiskAPI'
import { createIssueAnalysis } from 'src/API/IssueApi'
import { ISSUE_RATINNG, ISSUE_RATINNG_THREE_CROSS } from 'src/Entities/IssueTypes'
import Loading from 'src/Common/ui/Loading'
import { useIssueStore } from './store/IssueStore'

const IssueAnalyzeEdit = ({ setIsEditTrue, issueDetailsData, formData, setformData, riskScore, setRiskScore, isEditTrue }) => {
    const { register, handleSubmit, setValue, formState: { errors, isSubmitting, isLoading }, control } = useForm({
        mode: 'onChange',
        defaultValues: {
            ImpactOfRiskScore: formData?.ImpactOfRiskScore,
            impactProbabilityJustification: formData?.impactProbabilityJustification,
            treePointDiscription: formData?.threePointEstimate?.treePointDiscription,
            decisionDiscription: formData?.decisionTreeAnalysis?.decisionDiscription,
            noOfAlternatives: formData?.decisionTreeAnalysis?.noOfAlternatives,
            alternativesData: formData?.decisionTreeAnalysis?.alternativesData?.map(mapData => ({
                id: mapData.id || 0,
                decisionTreeId: mapData.decisionTreeId || 0,
                alternativeName: mapData.alternativeName || '',
                outcomeNo: mapData.noOfOutcome || '',
                outcomes: mapData.outcomesData?.map(chMapData => ({
                    id: chMapData.id || 0,
                    alternativeId: chMapData.alternativeId || 0,
                    outcomeDescription: chMapData.outComesDiscription || '',
                    probability: chMapData.probability || '',
                    cost: chMapData.outComesCost || '',
                    days: chMapData.outComesDays || ''
                })) || []
            })) || [],
            noOfRisksData: formData?.noOfRisksData?.map(mapDt => ({
                id: mapDt.id || 0,
                riskId: mapDt.riskId || Number(issueDetailsData?.issueInformation?.id) || 0,
                emvId: mapDt.emvId || 0,
                riskName: mapDt.riskName || '',
                probability: mapDt.probability || '',
                cost: mapDt.cost || ''
            })) || [],
            noOfRisks: formData?.noOfRisks
        }
    })
    const { getIssueDetailsById } = useIssueStore()

    const navigate = useNavigate()
    // const { CreateRiskAnalysis, getRidkDetailsById } = useRiskStore()
    const [ initialRiskScore, setinitialRiskScore ] = useState({ impact: null, Probability: null, RiskScore: null })
    const [ open, setOpen ] = useState(false)
    const [ heatMapSelection, setheatMapSelection ] = useState(true)
    const [ selectedBox, setSelectedBox ] = useState(null)
    const [ tabsValue, setTabsValue ] = useState(0)
    const [ quantitativeRiskAssesmentArray, setQuantitativeRiskAssesmentArray ] = useState([{ id: 1, isChecked: false, title: 'Three-point estimate' }, { id: 2, isChecked: false, title: 'Decision tree analysis' }, { id: 3, isChecked: false, title: 'Expected monetary value (EMV)' }])
    const [ estimationArray, setEstimationArray ] = useState([{ id: 1, isChecked: true, title: 'Cost Estimation' }, { id: 2, isChecked: true, title: 'Duration Estimation' }])
    const [ decisionArray, setDecisionArray ] = useState([{ id: 1, isChecked: true, title: 'Cost Decision' }, { id: 2, isChecked: true, title: 'Duration Decision' }])
    const loginId = localStorage.getItem('userId')
    const userName = localStorage.getItem('userName')
    const { t } = useTranslation()

    const decisionTreeAnalysis = issueDetailsData?.analyzeResponse?.decisionTreeAnalysis
    const expectedMonetaryValue = issueDetailsData?.analyzeResponse?.expectedMonetaryValue
    const threePointEstimateValue = issueDetailsData?.analyzeResponse?.threePointEstimate

    const { configurationData, getConfigurationBasedOrganization } = useSettingsStore()
    const orgId = localStorage.getItem('orgId')
    useEffect(() => {
        getConfigurationBasedOrganization(orgId)
    }, [])
    useEffect(() => {
        if (configurationData.length > 0) {
            const data = configurationData?.filter(element => element.kindId === 5)
            const heatmap = data?.find(element => element.values === 1)?.subtitleName
            setheatMapSelection(heatmap === '5x5 Heat Map')
        }
    }, [configurationData])
    useEffect(() => {
        const updatedArray = quantitativeRiskAssesmentArray.map(item => {
            if (item.id === 1) {
                return {
                    ...item,
                    isChecked: !!(threePointEstimateValue?.id && threePointEstimateValue?.description?.length > 0)
                }
            }
            if (item.id === 2) {
                return {
                    ...item,
                    isChecked: !!(decisionTreeAnalysis?.alternativesNo > 0 && decisionTreeAnalysis?.id)
                }
            }
            if (item.id === 3) {
                return {
                    ...item,
                    isChecked: !!(expectedMonetaryValue?.risksNo > 0 && expectedMonetaryValue?.id)
                }
            }
            return item
        })
        const filterCheckedValue = updatedArray?.filter((filterData) => filterData?.isChecked === true)
        setTabsValue(filterCheckedValue[filterCheckedValue?.length - 1]?.id || 0)
        setQuantitativeRiskAssesmentArray(updatedArray)
    }, [ decisionTreeAnalysis, expectedMonetaryValue, threePointEstimateValue ])

    useEffect(() => {
        if (isEditTrue) {
            setformData(formData)
            setRiskScore(riskScore)

            setValue('ImpactOfRiskScore', formData?.ImpactOfRiskScore || '')
            setValue('impactProbabilityJustification', formData?.impactProbabilityJustification || '')
            setValue('treePointDiscription', formData?.threePointEstimate?.treePointDiscription || '')
            setValue('decisionDiscription', formData?.decisionTreeAnalysis?.decisionDiscription || '')
            setValue('noOfAlternatives', formData?.decisionTreeAnalysis?.noOfAlternatives || '')
            setValue('noOfRisks', formData?.noOfRisks || '')

            if (formData?.decisionTreeAnalysis?.alternativesData) {
                formData.decisionTreeAnalysis.alternativesData.forEach((alt, index) => {
                    setValue(`alternativeName${index}`, alt.alternativeName || '')
                    setValue(`noOfOutcome${index}`, alt.noOfOutcome || '')

                    alt.outcomesData?.forEach((outcome, outcomeIndex) => {
                        setValue(`outComesDiscription${index}${outcomeIndex}`, outcome.outComesDiscription || '')
                    })
                })
            }

            if (formData?.noOfRisksData) {
                formData.noOfRisksData.forEach((risk, index) => {
                    setValue(`riskName_${index}`, risk.riskName || '')
                })
            }
        }
    }, [ isEditTrue, formData, setValue ])

    // useEffect(() => {
    //     if ((!expectedMonetaryValue?.id || expectedMonetaryValue?.id === 0) && (!decisionTreeAnalysis?.id || decisionTreeAnalysis?.id === 0)) {
    //         setformData({
    //             ...formData,
    //             noOfRisks: 1,
    //             noOfRisksData: Array?.from({ length: 1 })?.map((_, mapIdx) => {
    //                 return {
    //                     riskName: '',
    //                     probability: null,
    //                     cost: null
    //                 }
    //             }),
    //             decisionTreeAnalysis: {
    //                 decisionDiscription: '',
    //                 noOfAlternatives: 1,
    //                 alternativesData: [
    //                     {
    //                         alternativeName: '',
    //                         noOfOutcome: 1,
    //                         outcomesData: [
    //                             { outComesDiscription: '', outComesProbability: null, outComesCost: null, outComesDays: null }
    //                         ]
    //                     }
    //                 ]
    //             }
    //         })
    //     } else if (!expectedMonetaryValue?.id || expectedMonetaryValue?.id === 0) {
    //         setformData({
    //             ...formData,
    //             noOfRisks: 1,
    //             noOfRisksData: Array?.from({ length: 1 })?.map((_, mapIdx) => {
    //                 return {
    //                     riskName: '',
    //                     probability: null,
    //                     cost: null
    //                 }
    //             })
    //         })
    //     } else if (!decisionTreeAnalysis?.id || decisionTreeAnalysis?.id === 0) {
    //         setformData({
    //             ...formData,
    //             decisionTreeAnalysis: {
    //                 decisionDiscription: '',
    //                 noOfAlternatives: 1,
    //                 alternativesData: [
    //                     {
    //                         alternativeName: '',
    //                         noOfOutcome: 1,
    //                         outcomesData: [
    //                             { outComesDiscription: '', outComesProbability: null, outComesCost: null, outComesDays: null }
    //                         ]
    //                     }
    //                 ]
    //             }
    //         })
    //     }
    // }, [ expectedMonetaryValue?.id, decisionTreeAnalysis?.id ])

    const handleClose = () => {
        setOpen(false)
        setinitialRiskScore({ impact: null, Probability: null, RiskScore: null })
    }
    const onValueChange = (value, name, index, chIdx) => {
        if (name === 'noOfAlternatives') {
            setformData({
                ...formData,
                decisionTreeAnalysis: {
                    ...formData?.decisionTreeAnalysis,
                    noOfAlternatives: value,
                    alternativesData: Array?.from({ length: value })?.map((_, mapIdx) => {
                        return {
                            alternativeName: '',
                            noOfOutcome: 1,
                            outcomesData: [
                                { outComesDiscription: '', outComesProbability: null, outComesCost: null, outComesDays: null }
                            ]
                        }
                    })
                }
            })
        }
        if (name === 'ImpactOfRiskScore' || name === 'impactProbabilityJustification') {
            setformData({
                ...formData,
                [name]: value?.slice(0, 250)
            })
        }
        if (name === 'decisionDiscription') {
            setformData(prevstate => ({
                ...prevstate,
                decisionTreeAnalysis: {
                    ...prevstate?.decisionTreeAnalysis,
                    decisionDiscription: value
                }
            }))
            // setformData({
            //     ...formData,
            //     decisionTreeAnalysis: {
            //         ...formData?.decisionTreeAnalysis,
            //         decisionDiscription: value
            //     }
            // })
        }
        if (name === 'alternativeName') {
            setformData({
                ...formData,
                decisionTreeAnalysis: {
                    ...formData?.decisionTreeAnalysis,
                    alternativesData: formData?.decisionTreeAnalysis?.alternativesData?.map((mapDt, mapIdx) => {
                        if (index === mapIdx) {
                            return { ...mapDt, alternativeName: value }
                        } else {
                            return mapDt
                        }
                    })
                }
            })
        }
        if (name === 'noOfOutcome') {
            setformData({
                ...formData,
                decisionTreeAnalysis: {
                    ...formData?.decisionTreeAnalysis,
                    alternativesData: formData?.decisionTreeAnalysis?.alternativesData?.map((mapDt, mapIdx) => {
                        if (index === mapIdx) {
                            return {
                                ...mapDt,
                                noOfOutcome: value,
                                outcomesData: Array?.from({ length: value })?.map((_, idx) => {
                                    return { outComesDiscription: '', outComesProbability: null, outComesCost: null, outComesDays: null }
                                })
                            }
                        } else {
                            return mapDt
                        }
                    })
                }
            })
        }
        if (name === 'outComesDays' || name === 'outComesCost' || name === 'outComesProbability' || name === 'outComesDiscription') {
            setformData({
                ...formData,
                decisionTreeAnalysis: {
                    ...formData?.decisionTreeAnalysis,
                    alternativesData: formData?.decisionTreeAnalysis?.alternativesData?.map((mapDt, mapIdx) => {
                        if (index === mapIdx) {
                            return {
                                ...mapDt,
                                outcomesData: mapDt?.outcomesData?.map((chMapDt, chMapIdx) => {
                                    if (chIdx === chMapIdx) {
                                        return { ...chMapDt, [name]: value }
                                    } else {
                                        return chMapDt
                                    }
                                })
                            }
                        } else {
                            return mapDt
                        }
                    })
                }
            })
        }
        if (name === 'noOfRisks') {
            setformData({
                ...formData,
                noOfRisks: value,
                noOfRisksData: Array?.from({ length: value })?.map((_, mapIdx) => {
                    return { riskName: '', probability: null, cost: null }
                })
            })
        }
        if (name === 'treePointDiscription' || name === 'optimisticCost' || name === 'optimisticDays' || name === 'pessimisticDays' || name === 'pessimisticCost' || name === 'mostLikelyDays' || name === 'mostLikelyCost') {
            setformData({
                ...formData,
                threePointEstimate: {
                    ...formData?.threePointEstimate,
                    [name]: value
                }
            })
        }
        if (name === 'cost' || name === 'riskName' || name === 'probability') {
            setformData({
                ...formData,
                noOfRisksData: formData?.noOfRisksData?.map((mapData, mapIdx) => {
                    if (mapIdx === index) {
                        return { ...mapData, [name]: value }
                    } else {
                        return mapData
                    }
                })
            })
        }
    }

    const chipColorStyle = riskScoreValue => {
        let textColor = 'hsl(var(--foreground))'
        if (riskScoreValue === RiskTypes.CHIP_CONTROLLED || riskScoreValue === IssueTypes.CHIP_VERY_LOW) {
            textColor = 'hsl(var(--Controlled))'
        } else if (riskScoreValue === RiskTypes.CHIP_LOW) {
            textColor = 'hsl(var(--Low))'
        } else if (riskScoreValue === RiskTypes.CHIP_MEDIUM) {
            textColor = 'hsl(var(--Medium))'
        } else if (riskScoreValue === RiskTypes.CHIP_HIGH) {
            textColor = 'hsl(var(--High))'
        } else if (riskScoreValue === RiskTypes.CHIP_EXTREME || riskScoreValue === IssueTypes.CHIP_VERY_HIGH) {
            textColor = 'hsl(var(--Extreme))'
        }
        return textColor
    }

    const handleSave = () => {
        setRiskScore(initialRiskScore)
        setOpen(false)
    }

    const handleChange = (event, newValue) => {
        setTabsValue(event)
    }
    function getLabelByScore (score) {
        if (score >= 1 && score <= 5) return 'Very Low'
        if (score >= 6 && score <= 10) return 'Low'
        if (score >= 11 && score <= 15) return 'Medium'
        if (score >= 16 && score <= 20) return 'High'
        if (score >= 21 && score <= 25) return 'Very High'
        return 'Unknown'
    }

    const handleBoxClick = (x, y) => {
        const RiskScore = IssueTypes.ISSUE_SCROING_DATA[y][x]?.value
        const impact = x < IssueTypes.ISSUE_SCROING_DATA[0].length - 1
            ? IssueTypes.ISSUE_SCROING_DATA[y][IssueTypes.ISSUE_SCROING_DATA[0].length - 1]?.value
            : RiskScore

        const Probability = y < IssueTypes.ISSUE_SCROING_DATA.length - 1 ? IssueTypes.ISSUE_SCROING_DATA[IssueTypes.ISSUE_SCROING_DATA.length - 1][x]?.value : RiskScore

        setinitialRiskScore({
            impact: getLabelByScore(impact),
            Probability: `${IssueTypes.xLabels[IssueTypes.PROBABILITY_VALUE.indexOf(Probability)]}`,
            RiskScore: `${
  [ IssueTypes.ISSUE_SCORE_ONE, IssueTypes.ISSUE_SCORE_TWO, IssueTypes.ISSUE_SCORE_SIX ].includes(RiskScore)
      ? IssueTypes.ISSUE_LEVEL_VERY_LOW
      : [ IssueTypes.ISSUE_SCORE_THREE, IssueTypes.ISSUE_SCORE_FOUR, IssueTypes.ISSUE_SCORE_FIVE,
          IssueTypes.ISSUE_SCORE_SEVEN, IssueTypes.ISSUE_SCORE_EIGHT,
          IssueTypes.ISSUE_SCORE_ELEVEN, IssueTypes.ISSUE_SCORE_TWELVE, IssueTypes.ISSUE_SCORE_SIXTEEN ]
          .includes(RiskScore)
          ? IssueTypes.ISSUE_LEVEL_LOW
          : [ IssueTypes.ISSUE_SCORE_NINE, IssueTypes.ISSUE_SCORE_THIRTEEN, IssueTypes.ISSUE_SCORE_SEVENTEEN ]
              .includes(RiskScore)
              ? IssueTypes.ISSUE_LEVEL_MEDIUM
              : [ IssueTypes.ISSUE_SCORE_TEN, IssueTypes.ISSUE_SCORE_FOURTEEN, IssueTypes.ISSUE_SCORE_FIFTEEN,
                  IssueTypes.ISSUE_SCORE_EIGHTEEN, IssueTypes.ISSUE_SCORE_NINETEEN,
                  IssueTypes.ISSUE_SCORE_TWENTY_TWO, IssueTypes.ISSUE_SCORE_TWENTY_THREE ]
                  .includes(RiskScore)
                  ? IssueTypes.ISSUE_LEVEL_HIGH
                  : [ IssueTypes.ISSUE_SCORE_TWENTY, IssueTypes.ISSUE_SCORE_TWENTY_ONE,
                      IssueTypes.ISSUE_SCORE_TWENTY_FOUR, IssueTypes.ISSUE_SCORE_TWENTY_FIVE ]
                      .includes(RiskScore)
                      ? IssueTypes.ISSUE_LEVEL_VERY_HIGH
                      : ''
}`

        })
    }

    const handleThreeCrossBoxClick = (x, y) => {
        const RiskScore = IssueTypes.ISSUE_SCROING_DATA_THREE_CROSS[y][x]?.value
        const impact = x > 0 ? IssueTypes.ISSUE_SCROING_DATA_THREE_CROSS[y][0]?.value : RiskScore
        const Probability = y < IssueTypes.ISSUE_SCROING_DATA_THREE_CROSS.length - 1 ? IssueTypes.ISSUE_SCROING_DATA_THREE_CROSS[IssueTypes.ISSUE_SCROING_DATA_THREE_CROSS.length - 1][x]?.value : RiskScore

        setinitialRiskScore({
            impact: `${IssueTypes.Y_LABLES_THREE_CROSS[IssueTypes.IMPACT_VALUE_THREE_CROSS.indexOf(impact)]}`,
            Probability: `${IssueTypes.X_LABLES_THREE_CROSS[IssueTypes.PROBABILITY_VALUE_THREE_CROSS.indexOf(Probability)]}`,
            RiskScore: `${(RiskScore === IssueTypes.ISSUE_SCORE_ONE || RiskScore === IssueTypes.ISSUE_SCORE_TWO)
                ? IssueTypes.ISSUE_LEVEL_LOW
                : (RiskScore === IssueTypes.ISSUE_SCORE_THREE || RiskScore === IssueTypes.ISSUE_SCORE_FOUR)
                    ? IssueTypes.ISSUE_LEVEL_MEDIUM
                    : (RiskScore === IssueTypes.ISSUE_SCORE_SIX || RiskScore === IssueTypes.ISSUE_SCORE_NINE) && IssueTypes.ISSUE_LEVEL_VERY_HIGH}`
        })
    }

    const onCheckboxValueChange = (value, data) => {
        if ((!data?.isChecked && data?.id === 3) && (!expectedMonetaryValue?.id || expectedMonetaryValue?.id === 0 || expectedMonetaryValue?.risksNo === 0 || !expectedMonetaryValue?.risksNo)) {
            setformData({
                ...formData,
                noOfRisks: 1,
                noOfRisksData: Array?.from({ length: 1 })?.map((_, mapIdx) => {
                    return {
                        riskName: '',
                        probability: null,
                        cost: null
                    }
                })
            })
        } else if ((data?.isChecked && data?.id === 3) && (!expectedMonetaryValue?.id || expectedMonetaryValue?.id === 0 || expectedMonetaryValue?.risksNo === 0 || !expectedMonetaryValue?.risksNo)) {
            setformData({
                ...formData,
                noOfRisks: 0,
                noOfRisksData: []
            })
        } else if ((!data?.isChecked && data?.id === 2) && (!decisionTreeAnalysis?.id || decisionTreeAnalysis?.id === 0 || !decisionTreeAnalysis?.alternativesNo || decisionTreeAnalysis?.alternativesNo === 0)) {
            setformData({
                ...formData,
                decisionTreeAnalysis: {
                    decisionDiscription: '',
                    noOfAlternatives: 1,
                    alternativesData: [
                        {
                            alternativeName: '',
                            noOfOutcome: 1,
                            outcomesData: [
                                { outComesDiscription: '', outComesProbability: null, outComesCost: null, outComesDays: null }
                            ]
                        }
                    ]
                }
            })
        } else if ((data?.isChecked && data?.id === 2) && (!decisionTreeAnalysis?.id || decisionTreeAnalysis?.id === 0 || !decisionTreeAnalysis?.alternativesNo || decisionTreeAnalysis?.alternativesNo === 0)) {
            setformData({
                ...formData,
                decisionTreeAnalysis: {
                    decisionDiscription: '',
                    noOfAlternatives: 0,
                    alternativesData: []
                }
            })
        }
        const newValue = quantitativeRiskAssesmentArray?.map((mapData, mapIdx) => {
            if (mapData?.id === data?.id) {
                return { ...mapData, isChecked: !mapData?.isChecked }
            } else {
                return mapData
            }
        })
        const filterCheckedValue = newValue?.filter((filterData) => filterData?.isChecked === true)
        setTabsValue(filterCheckedValue[filterCheckedValue?.length - 1]?.id || 0)
        setQuantitativeRiskAssesmentArray(newValue)
    }

    const handleCancel = () => {
        setIsEditTrue(false)
    }
    const [ loading, setLoading ] = useState(false)
    const handleSaveEdit = (message) => {
        const postRequestData = {
            createQualitativeRiskAssessmentRequest: {
                id: isEditTrue ? issueDetailsData?.analyzeResponse?.qualitativeRiskAssessment?.id || 0 : 0,
                riskId: Number(issueDetailsData?.issueInformation?.id),
                user: userName,
                impact: riskScore?.impact,
                probability: riskScore?.Probability,
                riskScore: riskScore?.RiskScore,
                probabilityJustification: formData?.impactProbabilityJustification,
                impactOfRisk: formData?.ImpactOfRiskScore,
                status: RiskTypes.MITIGATION,
                levelId: 0,
                userId: Number(loginId),
                createdBy: isEditTrue ? Number(issueDetailsData?.analyzeResponse?.qualitativeRiskAssessment?.createdBy) || Number(loginId) : Number(loginId),
                createdAt: isEditTrue ? issueDetailsData?.analyzeResponse?.qualitativeRiskAssessment?.createdAt || new Date().toISOString() : new Date().toISOString(),
                modifiedBy: Number(loginId),
                modifiedAt: new Date().toISOString()
            },
            threePointEstimateRequest: formData?.threePointEstimate?.treePointDiscription?.length > 0
                ? {
                    id: isEditTrue ? formData?.threePointEstimate?.id || 0 : 0,
                    riskId: Number(issueDetailsData?.issueInformation?.id),
                    estimateId: estimationArray?.find(item => item.title === 'Duration Estimation')?.isChecked && estimationArray?.find(item => item.title === 'Cost Estimation')?.isChecked ? 3 : estimationArray?.find(item => item.title === 'Cost Estimation')?.isChecked ? 1 : estimationArray?.find(item => item.title === 'Duration Estimation')?.isChecked && 2,
                    description: formData?.threePointEstimate?.treePointDiscription,
                    optimisticCost: estimationArray[0]?.isChecked ? formData?.threePointEstimate?.optimisticCost : 0,
                    mostLikelyCost: estimationArray[0]?.isChecked ? formData?.threePointEstimate?.mostLikelyCost : 0,
                    pessimisticCost: estimationArray[0]?.isChecked ? formData?.threePointEstimate?.pessimisticCost : 0,
                    optimisticDays: estimationArray[1]?.isChecked ? formData?.threePointEstimate?.pessimisticDays : 0,
                    mostLikelyDays: estimationArray[1]?.isChecked ? formData?.threePointEstimate?.mostLikelyDays : 0,
                    pessimisticDays: estimationArray[1]?.isChecked ? formData?.threePointEstimate?.pessimisticDays : 0,
                    costEstimation: formData?.threePointEstimate?.costEstimation,
                    durationEstimation: formData?.threePointEstimate?.durationEstimation
                }
                : null,
            decisionTreeAnalysisRequest: formData?.decisionTreeAnalysis?.noOfAlternatives > 0
                ? {
                    id: isEditTrue ? formData?.decisionTreeAnalysis?.id || 0 : 0,
                    riskId: formData?.decisionTreeAnalysis?.noOfAlternatives > 0 ? Number(issueDetailsData?.issueInformation?.id) : 0,
                    decisionId: formData?.decisionTreeAnalysis?.noOfAlternatives > 0 ? decisionArray?.find(item => item.title === 'Duration Decision')?.isChecked && decisionArray?.find(item => item.title === 'Cost Decision')?.isChecked ? 3 : decisionArray?.find(item => item.title === 'Cost Decision')?.isChecked ? 1 : decisionArray?.find(item => item.title === 'Duration Decision')?.isChecked && 2 : 0,
                    description: formData?.decisionTreeAnalysis?.decisionDiscription,
                    alternativesNo: formData?.decisionTreeAnalysis?.noOfAlternatives,
                    alternatives: formData?.decisionTreeAnalysis?.alternativesData?.map((mapData, mapIdx) => {
                        return {
                            id: isEditTrue ? mapData?.id || 0 : 0,
                            decisionTreeId: isEditTrue ? mapData?.decisionTreeId || 0 : 0,
                            alternativeName: mapData?.alternativeName,
                            outcomeNo: mapData?.noOfOutcome,
                            outcomes: mapData?.outcomesData?.map((chMapData, chMapIdx) => {
                                return {
                                    id: isEditTrue ? chMapData?.id || 0 : 0,
                                    alternativeId: isEditTrue ? chMapData?.alternativeId || 0 : 0,
                                    outcomeDescription: chMapData?.outComesDiscription,
                                    probability: chMapData?.probability,
                                    cost: decisionArray[0]?.isChecked ? chMapData?.outComesCost : 0,
                                    days: decisionArray[0]?.isChecked ? chMapData?.outComesDays : 0
                                }
                            })
                        }
                    }),
                    costDecision: formData?.decisionTreeAnalysis?.bestCostAlternative,
                    dayDecision: formData?.decisionTreeAnalysis?.bestDaysAlternative
                }
                : null,
            expectedMonetaryValueRequest: formData?.noOfRisks > 0
                ? {
                    id: isEditTrue ? formData?.emvId || 0 : 0,
                    riskId: formData?.noOfRisks > 0 ? Number(issueDetailsData?.issueInformation?.id) : 0,
                    risksNo: formData?.noOfRisks,
                    inputs: formData?.noOfRisksData?.map((mapDt, mapIdx) => {
                        return {
                            id: isEditTrue ? mapDt?.id || 0 : 0,
                            riskId: formData?.noOfRisks > 0 ? Number(issueDetailsData?.issueInformation?.id) : 0,
                            emvId: isEditTrue ? mapDt?.emvId || 0 : 0,
                            riskName: mapDt?.riskName,
                            probability: mapDt?.probability,
                            cost: mapDt?.cost
                        }
                    }),
                    totalEMV: formData?.totalEMV
                }
                : null
        }
        setLoading(true)
        createIssueAnalysis(postRequestData)
            .then((res) => {
                if (res?.data) {
                    toast.success(<p className='w-[100%] flex flex-row justify-evenly items-center' ><p>{message.replace('[ID]', issueDetailsData?.issueInformation?.referenceId)}</p></p>, {
                        position: 'top-right', theme: 'light'
                    })
                    getIssueDetailsById(Number(issueDetailsData?.issueInformation?.id), loginId)
                    setIsEditTrue(false)
                } else {
                    toast.error(<p className='w-[70%] flex flex-row justify-evenly items-center' ><p color='hsl(var(--card))'>Analyze stage has not been completed for Risk. Please try again!</p></p>, {
                        position: 'top-right', theme: 'light'
                    })
                }
                setLoading(false)
            }).catch(() => {
                setLoading(false)
            })
    }

    return (
        <div className='h-[100%] w-[100%]'>
            <Loading isLoading={loading} />
            <div className='h-[90%] w-[100%] p-4 overflow-auto'>
                <Typography variant="h6" sx={{ p: 1.5, borderRadius: '10px', color: 'hsl(var(--primary))', backgroundColor: 'hsl(var(--primary-foreground))' }}>Qualitative Issue Assessment</Typography>
                <Box display="grid" sx={{ }} gridTemplateColumns="repeat(12, 1fr)" gap={2}>
                    <Box gridColumn="span 7">
                        <div className='flex flex-row justify-end'>
                            <Button
                                variant='outlined'
                                component='label'
                                size='small'
                                style={{ marginTop: '2rem', width: '110px', marginBottom: '20px', height: '40px', fontWeight: 'bold', fontSize: '12px', color: 'hsl(var(--primary))', border: '2px solid hsl(var(--primary))' }}
                                onClick={() => { setOpen(true); setinitialRiskScore(riskScore) }}
                            >
                                <span className="flex items-center" style={{ fontWeight: 'bold' }}>
                                    <IoAdd className="mr-2" size={15} /> Add Score
                                </span>
                            </Button>
                        </div>
                        <div style={{ marginBottom: '2%' }}>
                            <table className="risk-table">
                                <thead>
                                    <tr className='bg-primary-foreground'>
                                        <th>Users</th>
                                        <th>Impact</th>
                                        <th>Probability</th>
                                        <th>Issue Level</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className='flex flex-col justify-center'>
                                            <span>{Number(riskScore?.userId) === Number(loginId) ? 'You' : riskScore?.user || '-'}</span>
                                            <span className='text-destructive'>{riskScore?.role || ''}</span>
                                        </td>
                                        <td>{riskScore?.impact || '-'}</td>
                                        <td>{riskScore?.Probability || '-'}</td>
                                        <td>
                                            {riskScore?.RiskScore ? <span className={'risk-level'} style={{ backgroundColor: chipColorStyle(riskScore?.RiskScore) }}>{riskScore?.RiskScore || '-'}</span> : '-'}
                                        </td>
                                        <td >{riskScore?.impact
                                            ? (<Tooltip title="Delete Score" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                                <RiDeleteBin5Line onClick={() => { setRiskScore({ impact: null, Probability: null, RiskScore: null }) }} size={24} className='cursor-pointer' color='hsl(var(--destructive))' />
                                            </Tooltip>)
                                            : ('-')}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </Box>
                    <Box gridColumn="span 6">
                        <div className="relative" style={{ marginBottom: '2%' }}>
                            <Textarea className={cn('ml-[0px]')} label="Impact / Probability Justification" rules={{
                                validate: (value) => {
                                    if (!value) return t('This field is required')
                                    if (value.length > 251) return t('Character count should not exceed 250')
                                    return true
                                }
                            }} register={register} value={formData?.impactProbabilityJustification} type="text" placeholder="Enter Impact/Probability Justification" onValueChange={onValueChange} name="impactProbabilityJustification" errors={errors} control={control} required maxLength={250} />
                            <div className={cn('absolute bottom-[25px] right-[10px] text-muted text-[10px]', formData?.impactProbabilityJustification?.length > 250 ? '!text-danger' : 'text-muted')}>{formData?.impactProbabilityJustification?.length || 0}/250</div>
                        </div>
                    </Box>
                    <Box gridColumn="span 6">
                        <div className="relative" style={{ marginBottom: '2%' }}>
                            <Textarea className={cn('ml-[0px]')} label="Impact of Issue" rules={{
                                validate: (value) => {
                                    if (!value) return t('This field is required')
                                    if (value.length > 251) return t('Character count should not exceed 250')
                                    return true
                                }
                            }} register={register} value={formData?.ImpactOfRiskScore} type="text" placeholder="Enter Impact of Issue" onValueChange={onValueChange} name="ImpactOfRiskScore" errors={errors} control={control} required maxLength={250} />
                            <div className={cn('absolute bottom-[25px] right-[10px] text-muted text-[10px]', formData?.ImpactOfRiskScore?.length > 250 ? '!text-danger' : 'text-muted')}>{formData?.ImpactOfRiskScore?.length || 0}/250</div>
                        </div>
                    </Box>
                </Box>
                <Typography variant="h6" sx={{ p: 1.5, borderRadius: '10px', color: 'hsl(var(--primary))', backgroundColor: 'hsl(var(--primary-foreground))' }}>Quantitative Issue Assessment</Typography>
                <Box container alignItems="center" sx={{ p: 2 }}>
                    <div className='flex flex-row py-4'>
                        {quantitativeRiskAssesmentArray?.map((mapDt, key) =>
                            <div key={key} className='flex mt-auto mb-4 pr-4'>
                                <Checkbox
                                    checked={mapDt?.isChecked}
                                    borderColor={`hsl(var(--${mapDt?.title}))`}
                                    onCheckedChange={(e) => onCheckboxValueChange(e, mapDt)}
                                    className={mapDt?.isChecked ? 'my-auto border-none' : 'my-auto'}
                                />
                                {mapDt?.title && <label className='grc-label ml-2'>{mapDt?.title}</label>}
                            </div>)}
                    </div>
                    <Tabs
                        style={{ paddingBottom: '20px' }}
                        defaultValue={1}
                        value={tabsValue}
                        onValueChange={handleChange}>
                        <TabsList>
                            {quantitativeRiskAssesmentArray?.filter((filterData) => filterData?.isChecked).map((mapDt, mapIdx) => <TabsTrigger style={{ marginRight: '10px', fontSize: '16px' }} key={mapIdx} value={mapDt?.id}>{mapDt?.title}</TabsTrigger>)}
                        </TabsList>
                    </Tabs>
                    <div>
                        {tabsValue === 1 && <div><ThreePointEstimate register={register} estimationArray={estimationArray} setEstimationArray={setEstimationArray} formData={formData} setformData={setformData} onValueChange={onValueChange} errors={errors} control={control} /></div>}
                        {tabsValue === 2 && <div><DecisionTreeAnalysis register={register} decisionArray={decisionArray} setDecisionArray={setDecisionArray} formData={formData} setformData={setformData} onValueChange={onValueChange} errors={errors} control={control} /></div>}
                        {tabsValue === 3 && <div><ExpectedMonetaryValue register={register} estimationArray={estimationArray} setEstimationArray={setEstimationArray} formData={formData} setformData={setformData} onValueChange={onValueChange} errors={errors} control={control} type={'ISSUE'} /></div>}
                    </div>
                </Box>
                <Dialog
                    maxWidth
                    open={open}
                    onClose={handleClose}
                >
                    <Box sx={{ width: 1000 }} >
                        <DialogTitle sx={{ padding: '0px 10px 0px 10px', display: 'flex', alignItems: 'center', backgroundColor: 'hsl(var(--primary))', flexDirection: 'row', height: '40px', justifyContent: 'center' }}>
                            <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#fff' }}>Choose Issue Score</div>
                        </DialogTitle>
                        <DialogContent>
                            <div style={{ width: '100%', display: 'flex', flexDirection: 'row' }}>
                                <div style={{ width: '45%', padding: '30px' }}>
                                    <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                        <img src='/Assets/Priority.svg' style={{ height: '260px' }} alt="Impact" />
                                        <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                            {heatMapSelection
                                                ? <Heatmap
                                                    xLabels={IssueTypes.xLabels?.map((dt, indedx) => <p key={indedx} style={{ fontSize: '10px' }} >{dt}</p>)}
                                                    yLabels={IssueTypes.yLabels.map((dt, indedx) => <p key={indedx} style={{ fontSize: '10px', marginLeft: '-50px' }} >{dt}</p>)}
                                                    xLabelsLocation={'bottom'}
                                                    xLabelWidth={50}
                                                    data={IssueTypes.ISSUE_SCROING_DATA}
                                                    squares
                                                    height={50}
                                                    onClick={(x, y) => {
                                                        handleBoxClick(x, y)
                                                        setSelectedBox({ x, y })
                                                    }}
                                                    cellStyle={(background, value, min, max, data, x, y) => ({
                                                        fontSize: '12.5px',
                                                        backgroundColor: value?.color,
                                                        color: '#fff',
                                                        border: selectedBox && selectedBox.x === x && selectedBox.y === y ? '7px solid #ffffff6e' : 'none'
                                                    })}
                                                    // cellRender={value => value && <div>{value.value}</div>}
                                                />
                                                : <Heatmap
                                                    xLabels={IssueTypes.X_LABLES_THREE_CROSS?.map((dt, indedx) => <p key={indedx} style={{ fontSize: '10px' }} >{dt}</p>)}
                                                    yLabels={IssueTypes.Y_LABLES_THREE_CROSS?.map((dt, indedx) => <p key={indedx} style={{ fontSize: '10px', marginLeft: '-50px' }} >{dt}</p>)}
                                                    xLabelsLocation={'bottom'}
                                                    xLabelWidth={50}
                                                    data={IssueTypes.ISSUE_SCROING_DATA_THREE_CROSS}
                                                    squares
                                                    height={50}
                                                    onClick={(x, y) => {
                                                        handleThreeCrossBoxClick(x, y)
                                                        setSelectedBox({ x, y })
                                                    }}
                                                    cellStyle={(background, value, min, max, data, x, y) => ({
                                                        fontSize: '12.5px',
                                                        backgroundColor: value?.color,
                                                        color: '#fff',
                                                        border: selectedBox && selectedBox.x === x && selectedBox.y === y ? '7px solid #ffffff6e' : 'none'
                                                    })}
                                                />}
                                        </div>
                                    </div>
                                    <img src='/Assets/Severity.svg' style={{ paddingLeft: '60px', marginLeft: '21px', paddingTop: '20px', marginBottom: '-40px' }} alt="Impact" />
                                </div>
                                <span style={{
                                    display: 'inline-block',
                                    width: '2px',
                                    backgroundColor: 'hsl(var(--primary-foreground))',
                                    margin: ' 0 10px',
                                    height: ' 22em'
                                }} />
                                <div style={{ width: '55%', marginLeft: '1rem', display: 'flex', flexDirection: 'column' }}>
                                    <Box display="grid" className='w-[100%] h-full'>
                                        <div style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', fontSize: '13px' }}>
                                            <p style={{ fontWeight: 'bold', marginRight: '1rem', fontSize: '12px' }}>Issue Level</p>
                                            {heatMapSelection
                                                ? ISSUE_RATINNG?.map((data, ind) => {
                                                    return (
                                                        <div style={{ width: 65, border: '0.5px solid black', color: '#fff', textAlign: 'center', backgroundColor: data?.color, fontSize: '12px' }} key={ind} >{data?.title}</div>
                                                    )
                                                })
                                                : ISSUE_RATINNG_THREE_CROSS?.map((data, ind) => {
                                                    return (
                                                        <div style={{ width: 65, border: '0.5px solid black', color: '#fff', textAlign: 'center', backgroundColor: data?.color, fontSize: '12px' }} key={ind} >{data?.title}</div>
                                                    )
                                                })
                                            }
                                        </div>
                                        <Box gridColumn="span 12" className="max-w-30 font-medium">
                                            <h4 style={{ display: 'inline-block', marginRight: '0.2rem', color: 'hsl(var(--primary))' }}>
                                                    Impact :
                                            </h4>
                                            <span>
                                                {initialRiskScore?.impact || ''}
                                            </span>
                                        </Box>
                                        <Box gridColumn="span 12" className="max-w-30 font-medium">
                                            <h4 style={{ display: 'inline-block', marginRight: '0.2rem', color: 'hsl(var(--primary))' }}>
                                                Probability :
                                            </h4>
                                            <span>
                                                {initialRiskScore?.Probability || ''}
                                            </span>
                                        </Box>
                                        <Box gridColumn="span 12" className=" max-w-30 font-medium">
                                            <h4 style={{ display: 'inline-block', marginRight: '0.2rem', color: 'hsl(var(--primary))' }}>
                                                Issue Level :
                                            </h4>
                                            <span>
                                                <Chip
                                                    key={initialRiskScore?.RiskScore || ''}
                                                    label={initialRiskScore?.RiskScore || ''}
                                                    sx={{
                                                        width: '100px',
                                                        color: 'hsl(var(--foreground))',
                                                        backgroundColor: chipColorStyle(initialRiskScore?.RiskScore)
                                                    }}

                                                />
                                            </span>
                                        </Box>
                                    </Box>
                                </div>
                            </div>
                        </DialogContent>
                        <DialogActions style={{ width: '100%', display: 'flex', padding: '15px 30px 15px 30px', flexDirection: 'row', justifyContent: 'flex-end' }}>
                            <div className='d-flex content-end'>
                                <SaveCancelButton handleCancel={handleClose} handleSave={handleSave} />
                            </div>
                        </DialogActions>
                    </Box>
                </Dialog>
            </div>
            <div className='h-[10%]' >
                <Box sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'center', pr: 2 }}>
                    <Button variant='outline' style={{ marginRight: '16px', color: 'hsl(var(--destructive))', borderColor: 'hsl(var(--destructive))' }}
                        onClick={handleCancel}>{'Cancel'} </Button>
                    <Button style={{ color: 'hsl(var(--card))', borderColor: 'hsl(var(--card))' }}
                        onClick={handleSubmit(() => handleSaveEdit('Analyze stage has been completed for Issue [ID]'))} disabled={isLoading || isSubmitting}>{'Save'} </Button>
                </Box>
            </div>
        </div>
    )
}

export default IssueAnalyzeEdit
